export default __webpack_public_path__ + "static/media/fast_forward.2d55cfdb.svg";